module.exports = __webpack_public_path__ + "media/images/common/header/sub_qanda-d864807aa18fc11805fbf6428ade9712.svg";